import useAppConfig from '@hooks/useAppConfig';

const useAppMode = () => useAppConfig().data.appMode;

export default useAppMode;
